import React from 'react';
// ##### 24-05-10 Komarov
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### 24-02-20 Komarov

// ##### Komarov 2025-07-14
const PaxValue = ({ fontSize }) => {
  // ##### 24-05-13 Komarov
  const counterAdultsOuter = useSelector(
    state => state.hotelsContext.counterAdultsOuter
  );
  const counterChildOuter = useSelector(
    state => state.hotelsContext.counterChildOuter
  );
  const counterRoomsOuter = useSelector(
    state => state.hotelsContext.counterRoomsOuter
  );

  // ##### Komarov 2025-08-05
  const Adults = useLocalizedText('Adults');
  const Children = useLocalizedText('Children');
  const Rooms = useLocalizedText('Rooms');

  const totalPaxRedux = useSelector(state => state.paxchoice.pax);

  // ##### 25-05-10 Komarov
  const query = useValidateQuery();

  return (
    <div
      data-component="PaxValue"
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        fontSize,
      }}
    >
      {/* <Pax  /> */}
      <div
        style={{
          paddingLeft: '1vw',
          /* fontSize: '14px',  */
          alignContent: 'center',
        }}
      >
        <center>
          {/* ##### 24-05-10 Komarov */}
          {/* <b>{counterAdultsOuter}</b> { */}
          {
            <b>
              {totalPaxRedux?.adults || query?.adults || counterAdultsOuter}
            </b>
          }
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Adults
          }
          ,
        </center>
      </div>
      <div style={{ paddingLeft: '1vw' /* ,fontSize:'14px' */ }}>
        <center>
          {/* ##### 24-05-10 Komarov */}
          <b>
            {totalPaxRedux?.children || query?.children || counterChildOuter}
          </b>
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Children
          }
          ,
        </center>
      </div>
      <div style={{ paddingLeft: '1vw' /* ,fontSize:'14px' */ }}>
        <center>
          {/* ##### 24-05-10 Komarov */}
          <b>{totalPaxRedux?.rooms || query?.rooms || counterRoomsOuter}</b>
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Rooms
          }
        </center>
      </div>

      {/* ##### 23-03-30 Komarov */}
    </div>
  );
};

export default PaxValue;
